module.exports = "/_next/static/media/04b38a2663f56a4c87cb0e4e18415c5c.png";